<template>
  <div class="help-content-page">
    <div class="help-content-header">
      <a-input placeholder="请输入关键词搜索" v-model="keywords" />
      <a-button @click="btnSearch">搜索</a-button>
    </div>
    <div class="help-content-content" v-if="!isSearch">
      <div class="content-left">
        <div class="all-menu">
          <span>全部</span>
        </div>
        <a-menu mode="inline" :openKeys="openKeys" @openChange="onOpenChange" class="help-ant-menu">
          <a-sub-menu v-for="(item,index) in menuList" :key="index">
            <span slot="title">{{ item.name }}</span>
            <a-sub-menu v-for="(ite,inde) in item.childLocation" :key="index+inde+''" :title="ite.name">
              <a-menu-item v-for="(it,ind) in ite.childLocation" :key="index+inde+ind+''" @click="btnMenuIssueList(it)">{{ it.name }}</a-menu-item>
            </a-sub-menu>
          </a-sub-menu>
        </a-menu>
      </div>
      <div class="content-right">
        <div class="content-right-tabs">
          <a-tabs defaultActiveKey="1" @change="callback">
            <a-tab-pane key="1">
              <div slot="tab" class="tab-title">
                <span class="icon-image icon-image-quanbu"></span>
                <span>常见问题</span>
              </div>
              <div class="a-collapse-box">
                <a-collapse defaultActiveKey="1" :bordered="false">
                  <template v-slot:expandIcon="props">
                    <a-icon type="caret-right" :rotate="props.isActive ? 90 : 0" />
                  </template>
                  <a-collapse-panel v-for="(item,index) in issueList" :header="item.title" :key="index">
                    <p>{{ item.content }}</p>
                    <!-- <p>
                      <img src="@/assets/image/timg.jpg" alt="">
                    </p> -->
                  </a-collapse-panel>
                </a-collapse>
              </div>
            </a-tab-pane>
            <a-tab-pane key="2" forceRender>
              <div slot="tab" class="tab-title">
                <span class="icon-image icon-image-weiqueren"></span>
                <span>新手教程</span>
              </div>
              <div class="a-collapse-box">
                <a-collapse defaultActiveKey="1" :bordered="false">
                  <template v-slot:expandIcon="props">
                    <a-icon type="caret-right" :rotate="props.isActive ? 90 : 0" />
                  </template>
                  <a-collapse-panel v-for="(item,index) in issueList" :header="item.title" :key="index">
                    <p>{{ item.content }}</p>
                    <!-- <p>
                      <img src="@/assets/image/timg.jpg" alt="">
                    </p> -->
                  </a-collapse-panel>
                </a-collapse>
              </div>
            </a-tab-pane>
          </a-tabs>
        </div>
      </div>
    </div>
    <div class="help-content-content-search" v-else>
      <div class="search-content" v-if="issueList.length>0">
        <div class="a-collapse-box">
          <a-collapse defaultActiveKey="1" :bordered="false">
            <template v-slot:expandIcon="props">
              <a-icon type="caret-right" :rotate="props.isActive ? 90 : 0" />
            </template>
            <a-collapse-panel v-for="(item,index) in issueList" :key="index">
              <p slot="header" class="title-box">
                <span>{{ item.title }}</span>
                <span class="type-mark">常见问题</span>
              </p>
              <p>{{ item.content }}</p>
              <p>
                <img src="@/assets/image/timg.jpg" alt="">
              </p>
            </a-collapse-panel>
          </a-collapse>
        </div>
      </div>
      <div class="blank-search" v-else>
        <img src="@/assets/image/tab-none@2x.png" alt="">
        <span class="blank-text">暂无相关问题</span>
      </div>
    </div>
  </div>
</template>
<script>
import { listAllHelpCategory, listHelpCategoryByParentId, pageListHelpCenterByCategoryId } from "@/utils/api"
export default {
  name: 'helpContent',
  data () {
    return {
      rootSubmenuKeys: [],
      openKeys: [],
      text: '系统支持分批入库，如采购订单的商品因缺货或其他原因，需分批入库。生成采购单时，入库数量、商品可少于购货订单的数量、商品。这种购货单生成后，因购货订单的商品未全部入库，会显示“部分入库”。',
      form: this.$form.createForm(this),
      keywords: '',
      menuList: [],
      type: 1,
      categoryId: '',
      issueList: [],
      searchList: [],
      isSearch: false
    }
  },
  activated () {
    this.getlistAllHelpCategory()
    this.getPageList()
  },
  methods: {
    // 查询所有帮助分类的树状
    getlistAllHelpCategory () {
      let params = {}
      listAllHelpCategory(params).then((res) => {
        if (res.code == 200) {
          this.menuList = res.result
          console.log(this.menuList)
          this.menuList.map((item, index) => {
            this.getTwoHelp(item, index)
          })
        } else {
          this.$message.error(res.logMessage)
        }
      })
    },
    getTwoHelp (item, index) {
      let params = new FormData()
      params.append("parentId", item.id)
      listHelpCategoryByParentId(params).then((res) => {
        if (res.code == 200) {
          this.menuList[index].childLocation = res.result
          if (this.menuList[index].childLocation.length > 0) {
            this.menuList[index].childLocation.map((ite, inde) => {
              this.getThreeHelp(ite, index, inde)
            })
          }
        } else {
          this.$message.error(res.logMessage)
        }
      })
    },
    getThreeHelp (ite, index, inde) {
      let params = new FormData()
      params.append("parentId", ite.id)
      listHelpCategoryByParentId(params).then((res) => {
        if (res.code == 200) {
          this.menuList[index].childLocation[inde].childLocation = res.result
        } else {
          this.$message.error(res.logMessage)
        }
      })
    },
    // 搜索
    btnSearch () {
      if (this.keywords) {
        this.getPageList()
        this.isSearch = true
      } else {
        this.isSearch = false
        this.getPageList()
      }
    },
    // 选择左侧菜单
    btnMenuIssueList (it) {
      this.categoryId = it.id
      this.getPageList()
    },
    // 获取分页列表
    getPageList () {
      let data = {
        categoryId: this.categoryId,
        keywords: this.keywords,
        pageNo: 1,
        pageSize: 5,
        type: this.type
      }
      let params = {}
      this.$store.state.isLoding = true
      pageListHelpCenterByCategoryId(params, {}, data).then((res) => {
        if (res.code == 200) {
          this.issueList = res.result.records
          this.$store.state.isLoding = false
        } else {
          this.$message.error(res.logMessage)
        }
      })
    },
    onOpenChange (openKeys) {
      const latestOpenKey = openKeys.find(key => this.openKeys.indexOf(key) === -1);
      if (this.rootSubmenuKeys.indexOf(latestOpenKey) === -1) {
        this.openKeys = openKeys;
      } else {
        this.openKeys = latestOpenKey ? [latestOpenKey] : [];
      }
    },
    // tabs选择函数
    callback (e) {
      this.type = e
      this.getPageList()
    },
  }
}
</script>
<style lang="scss">
.help-content-page {
  .help-ant-menu {
    width: 240px !important;
  }
  .help-content-header {
    width: 100%;
    height: 100px;
    background-image: url("../../../assets/image/renwu.png");
    background-size: 100% 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    .ant-input {
      width: 400px;
      height: 40px !important;
    }
    .ant-btn {
      width: 80px;
      background: #fafafa;
      border: 1px solid #dedede;
      border-radius: 20px !important;
      color: #f87014;
      margin-left: 16px;
    }
  }
  .help-content-content {
    width: 100%;
    background-color: #ffffff;
    margin-top: 12px;
    display: flex;
    align-items: flex-start;
    min-height: calc(100vh - 270px);
    .content-left {
      width: 241px;
      .all-menu {
        padding: 20px 0 0 20px;
      }
      .ant-menu {
        height: 100%;
        border: 0;
        .ant-menu-submenu-title:hover,
        .ant-menu-item:hover {
          color: var(--co);
        }
        .ant-menu-item-selected {
          color: #878787;
          background-color: #f7f7f9;
        }
        .ant-menu-item-selected::after {
          border-color: var(--co);
        }
        .ant-menu-submenu-title:hover .ant-menu-submenu-arrow::after,
        .ant-menu-submenu-title:hover .ant-menu-submenu-arrow::before {
          background: var(--co);
        }
        // .ant-menu-sub.ant-menu-inline {
        //     padding-left: 16px;
        //     .ant-menu-item {
        //         padding-left: 16px;
        //     }
        // }
        .ant-menu-submenu-selected {
          color: #387bfc;
        }
      }
    }
    .content-right {
      width: 100%;
      padding: 38px 50px;
      border-left: 1px solid #e8e8e8;
      .content-right-tabs {
        .ant-tabs-bar {
          height: 64px;
          display: flex;
          align-items: center;
          background-color: #ffffff;
          margin: 0;

          .ant-tabs-ink-bar {
            display: none !important;
            background-color: var(--co);
          }

          .ant-tabs-tab {
            margin: 0;

            .tab-title {
              height: 32px;
              display: flex;
              align-items: center;
            }

            .icon-image {
              display: inline-block;
              width: 32px;
              height: 32px;
              background-size: 100%;
              margin-right: 8px;
            }

            .icon-image-quanbu {
              background-image: url("../../../assets/image/make_offers_quanbu.png");
            }

            .icon-image-weiqueren {
              background-image: url("../../../assets/image/icon_wbj wxz.png");
            }

            .icon-image-queren {
              background-image: url("../../../assets/image/icon_cgsp wxz.png");
            }
          }

          .ant-tabs-tab-active {
            color: #387bfc;

            .icon-image-quanbu {
              background-image: url("../../../assets/image/make_offers_quanbu1.png");
            }

            .icon-image-weiqueren {
              background-image: url("../../../assets/image/icon_wbj xz.png");
            }

            .icon-image-queren {
              background-image: url("../../../assets/image/icon_cgsp xz.png");
            }
          }

          .ant-tabs-nav .ant-tabs-tab:hover {
            color: #387bfc;

            .icon-image-quanbu {
              background-image: url("../../../assets/image/make_offers_quanbu1.png");
            }

            .icon-image-weiqueren {
              background-image: url("../../../assets/image/icon_wbj xz.png");
            }

            .icon-image-queren {
              background-image: url("../../../assets/image/icon_cgsp xz.png");
            }
          }
        }
      }
      .a-collapse-box {
        .ant-collapse-item {
          border: 0;
          .ant-collapse-header {
            background-color: #ffffff;
          }
          .ant-collapse-content-box {
            background-color: #f7f8fa;
            padding: 20px 20px !important;
            margin-left: 40px;
            p {
              margin: 0;
            }
          }
        }
      }
      .ant-tabs-content {
        height: calc(100vh - 400px);
        overflow: auto;
      }
    }
  }
  .help-content-content-search {
    background-color: #ffffff;
    margin-top: 12px;
    display: flex;
    align-items: flex-start;
    min-height: calc(100vh - 270px);
    padding: 36px;
    .a-collapse-box {
      width: 100%;
      .ant-collapse-item {
        border: 0;
        .ant-collapse-header {
          background-color: #ffffff;
          display: flex;
          align-items: center;
          .title-box {
            height: 30px;
            line-height: 30px;
            padding: 0;
            margin: 0;
            .type-mark {
              display: inline-block;
              height: 20px;
              line-height: 20px;
              width: 70px;
              font-size: 12px;
              background-color: rgba(22, 120, 255, 0.1);
              margin-left: 10px;
              color: #387cfc;
              border-radius: 20px 20px;
              text-align: center;
            }
          }
        }
        .ant-collapse-content-box {
          background-color: #f7f8fa;
          padding: 20px 20px !important;
          margin-left: 40px;
          p {
            margin: 0;
          }
        }
      }
    }
    .blank-search {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 8%;
      .blank-text {
          color: #878787;
          padding-left: 60px;
      }
    }
  }
}
</style>
